import { useEffect, useMemo, useState } from 'react';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { getToken, getMyInfo, getStoreAdmin, getXUserAgent } from 'utils/storages';

const getHeaders = () => {
  const token = getToken();
  const meInfo = getMyInfo();
  const storeAdmin = getStoreAdmin();
  const Authorization = `Bearer ${token}`;
  return {
    Accept: 'text/event-stream',
    Authorization,
    'X-User-Agent': getXUserAgent(),
    'X-Store-gsid': meInfo?.sid || storeAdmin?.said
  };
};

export const useQuerySubscription = (queryKey: any, url: string) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [eventSource, setEventSource] = useState(null);

  const connectSSE = () => {
    setLoading(true);
    const newEventSource = new EventSourcePolyfill(url, {
      headers: getHeaders(),
      withCredentials: false
    });
    newEventSource.addEventListener('update', (event) => {
      if (event?.data) {
        setData(JSON.parse(event.data));
        setLoading(false);
        newEventSource.close();
      }
    });
    newEventSource.onerror = (err) => {
      setError(err);
      setLoading(false);
      newEventSource.close();
    };
    setEventSource(newEventSource);
  };

  useEffect(() => {
    if (!queryKey) {
      setData(null);
      setError(null);
      return;
    }
    if (eventSource) {
      setEventSource(null);
    }
    connectSSE();
    // eslint-disable-next-line consistent-return
    return () => {
      eventSource?.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryKey, url]);

  return useMemo(() => {
    return { data, error, loading, refetch: connectSSE };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, loading]);
};
